import React from 'react'
import { Fade } from 'react-bootstrap'

import styled from 'styled-components'

export interface BackdropProps {
  children: React.ReactNode
}

export function Backdrop({ children }: BackdropProps) {
  return (
    <Fade appear in>
      <Container>{children}</Container>
    </Fade>
  )
}

const Container = styled.aside`
  background-color: rgb(255, 255, 255, 0.7);

  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 1000;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
